import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

const HeroIconsOutline = ({ iconId, ...rest }) => (
  <FuseSvgIcon {...rest}>{`heroicons-outline:${iconId}`}</FuseSvgIcon>
);
const HeroIconsSolid = ({ iconId, ...rest }) => (
  <FuseSvgIcon {...rest}>{`heroicons-solid:${iconId}`}</FuseSvgIcon>
);
const FilesIcons = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`files-icons:${iconId}`}</FuseSvgIcon>;
const CommonIcons = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`common:${iconId}`}</FuseSvgIcon>;
const MaterialSolid = ({ iconId, ...rest }) => (
  <FuseSvgIcon {...rest}>{`material-solid:${iconId}`}</FuseSvgIcon>
);
const MaterialOutline = ({ iconId, ...rest }) => (
  <FuseSvgIcon {...rest}>{`material-outline:${iconId}`}</FuseSvgIcon>
);
const Workflow = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`workflow:${iconId}`}</FuseSvgIcon>;
const Feather = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`feather:${iconId}`}</FuseSvgIcon>;
const Status = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`status:${iconId}`}</FuseSvgIcon>;
const NotificationsIcons = ({ iconId, ...rest }) => (
  <FuseSvgIcon {...rest}>{`notifications:${iconId}`}</FuseSvgIcon>
);
const TransactionMonitoring = ({ iconId, ...rest }) => (
  <FuseSvgIcon {...rest}>{`transaction-monitoring:${iconId}`}</FuseSvgIcon>
);
const HomePage = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`home-page:${iconId}`}</FuseSvgIcon>;
const Navigation = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`navigation:${iconId}`}</FuseSvgIcon>;
const SignIn = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`sign-in:${iconId}`}</FuseSvgIcon>;
const SignUp = ({ iconId, ...rest }) => <FuseSvgIcon {...rest}>{`sign-up:${iconId}`}</FuseSvgIcon>;

export {
  SignUp,
  SignIn,
  Status,
  Feather,
  HomePage,
  Navigation,
  Workflow,
  FilesIcons,
  CommonIcons,
  MaterialSolid,
  HeroIconsSolid,
  MaterialOutline,
  HeroIconsOutline,
  NotificationsIcons,
  TransactionMonitoring,
};
